import { ReactNode } from 'react'

import Typography from '@mui/material/Typography'

import * as S from './Title.styles'

const Title = ({ children }: { children: ReactNode | ReactNode[] }) => {
  return (
    <S.Root size={{ xs: 12 }}>
      <Typography variant="Sarabun H6">{children}</Typography>
    </S.Root>
  )
}

export default Title
